export default __webpack_public_path__ + "static/house3-3785f37a23975693555ca6549706c132.png";